export default {
  default: '系统未知错误,请反馈给管理员'
}
